<div class="modal-body modal-scss">
  {{ message }}
  @if (!confirmMode) {
    <i-button styleClass="bottomButton red" (click)="close()" [text]="'close' | translate"></i-button>
  }
  @if (confirmMode) {
    <i-button class="bottomButton red" (click)="close()" [text]="'global.no' | translate"></i-button>
  }
  @if (confirmMode) {
    <i-button styleClass="bottomButton green mb-2" (click)="close('true')" [text]="'global.yes' | translate"></i-button>
  }
</div>
